<template lang="pug">
  .location-faq
    .question(:id="indexId" :aria-expanded="s.val == index + 1" :class="{expanded: s.val == index + 1}")
      button.btn-reset(@click="toggle(s, index)")
        .question-texts
          p.question-text.bold.xs-f-small.max-at-tweak {{ faq.question?.mainQuestion }}
          .mt-10(v-if="faq?.question?.subTitleQuestion?.length")
            p.question-subtitle(v-for="subQ in faq?.question?.subTitleQuestion" :key="subQ") {{ subQ }}
        .icon
          mr-icon.xs-f-medium.max-at-tweak(:name="expandedIcon")

    .answer(role="region" :aria-labelledby="indexId" :aria-hidden="s.val != index + 1" :class="{expanded: s.val == index + 1}")
      .answer-inner-wrap
        p.max-at-tweak(v-html="faq.answer")

</template>
<script>
  export default {
    name: "LocationFAQ",

    props: {
      faq: {
        type: Object,
        default: () => {}
      },
      index: {
        type: Number,
        default: null
      },
      s: {
        type: Object,
        default: () => {}
      }
    },
    computed: {
      expandedIcon() {
        return this.s.val === 0 ? 'more' : 'less';
      },

      indexId() {
        return `faqs-with-icons-${this.index + 1}`;
      }
    },
    methods: {
      toggle(s, index) {
        if (s.val === 0) {
          this.trackMREvent('HCB Location Page - FAQs clicked');
        }
        s.toggleVal(index + 1);
      }
    }
  };
</script>
<style scoped lang="stylus">
  .location-faq
    .question
      position relative
      width 100%
      
      button
        display flex
        flex-direction row
        align-items center
        text-align left
        justify-content space-between
        position relative
        width 100%
        padding 1em 2em

        .question-texts
          padding-right 0.25em
          .question-text
            display inline-block
            vertical-align top
            padding-top 0.25em
        
        .icon
          .mr-icon
            color ui-color-1
            
            &:before
              transition transform 400ms ease

    .answer
      max-height 0
      transition max-height 500ms ease-out
      overflow hidden
      
      &.expanded
        max-height 100em
        transition max-height 500ms ease-in
      
      .answer-inner-wrap
        padding 1em 2em

</style>
  